import { render, staticRenderFns } from "./PagesCountRegionView.vue?vue&type=template&id=ae92df6c&scoped=true"
import script from "./PagesCountRegionView.vue?vue&type=script&lang=js"
export * from "./PagesCountRegionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae92df6c",
  null
  
)

export default component.exports